import type { RegionIssueAlertsFragment } from "../client/generated";
import { RegionIssueAlert } from "./RegionIssueAlert";

type Props = {
  fragment: RegionIssueAlertsFragment;
};

export function RegionIssueAlerts({ fragment }: Props) {
  return (
    <div className="p-4 flex flex-col gap-4">
      {fragment.issues.map((issue) => (
        <RegionIssueAlert key={issue.id} fragment={issue} />
      ))}
    </div>
  );
}
